import { regex_email } from "../constants/regex";
import { basicMsg } from "../helpers/swal_msg";

export const formValidator = (name, email, msg) => {
    let SweetAlertMsg = '';
    const name_len = name.trim().length;
    const email_len = email.trim().length;
    const msg_len = msg.trim().length;
    if (name_len > 2 && name_len <= 80) {
        if (email_len > 2 && email_len <= 100 && regex_email.test(email.trim())) {
            if (msg_len > 5 && msg_len <= 400) {
                return true
            } else SweetAlertMsg = 'Por favor, escriba un mensaje.';
        } else SweetAlertMsg = 'Por favor, ingrese una dirección de correo electrónico válida.';
    } else SweetAlertMsg = 'Por favor, ingrese su nombre completo.';
    basicMsg(SweetAlertMsg);
    return false;
}